$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });

});

function quickView() {
  $(".quick-view").on('click', function () {
    if ($('#quick-view').length == 0) {
      $("body").append('<div id="quick-view"><div class="qv-product-images" style="opacity: 0"><div class="qv-product-thumbnails"></div></div></div>');
    }

    setTimeout(function() {
        $('.fancybox-wrap').addClass('reposition-qv');
    }, 100);

    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);

    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;

      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      var limitedDesc = desc.split(/\s+/).slice(0, 50).join(' ');
      $('.qv-product-description').html(limitedDesc);
      $('.view-product').attr('href', url);

      $('.qv-product-images').empty().append('<div class="qv-product-thumbnails"></div>');

      $(images).each(function (i, image) {
        var largeImage = image.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
        var thumbImage = image.replace('.jpg', '_thumb.jpg').replace('.png', '_thumb.png');

        if (i === 0) {
          $('.qv-product-images').prepend('<div class="main-image-container"><img id="main-image" src="' + largeImage + '" alt="Product Image" height="500" /></div>');
        }
        if(images.length > 1){
          $('.qv-product-thumbnails').append('<div class="thumbnail-container"><img class="thumbnail" src="' + thumbImage + '" data-large="' + largeImage + '" alt="Thumbnail ' + (i + 1) + '" /></div>');
        }
      });

      $('.thumbnail').on('click', function () {
        var newSrc = $(this).data('large');
        $('#main-image').attr('src', newSrc);
      });

      $(options).each(function (i, option) {
        var opt = option.name;
        var selectHTML = '<div class="option-selection-container option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>';
        $('.qv-product-options').append(selectHTML);

        $(option.values).each(function (j, value) {
          $('.option-' + i).append('<option value="' + value + '">' + value + '</option>');
        });
      });

      updateVariantDetails(variants[0]);

      $('.qv-product-options').on('change', 'select', function () {
        var selectedOptions = [];
        $('.qv-product-options select').each(function () {
          selectedOptions.push($(this).val());
        });

        var matchedVariant = findMatchingVariant(variants, selectedOptions);
        if (matchedVariant) {
          updateVariantDetails(matchedVariant);
        }
      });
    });

    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      beforeLoad: function () {
        $("body").css({'overflow-y':'hidden'});
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });

          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart(var_id, qty);
              }
            });
          });
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      afterShow: function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });

        // Bind quantity button click events
        bindQuantityButtonEvents();
      },
      afterClose: function () {
        $("body").css({'overflow-y':'visible'});
        $('#quick-view').removeClass().empty();
      }
    });
  });
}

// Function to handle adding to cart
function processCart(var_id, qty) {
  jQuery.post('/cart/add.js', {
      quantity: qty,
      id: var_id
    },
    null,
    "json"
  ).done(function () {
    $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
    location.reload(); // Refresh the page after successful cart addition
  }).fail(function ($xhr) {
    var data = $xhr.responseJSON;
    $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
  });
}

function bindQuantityButtonEvents() {
  $('#qv-add-1-button').on('click', function() {
    var currentQuantity = parseInt($('.qv-quantity').val());
    $('.qv-quantity').val(currentQuantity + 1);
  });

  $('#qv-remove-1-button').on('click', function() {
    var currentQuantity = parseInt($('.qv-quantity').val());
    if (currentQuantity > 1) {
      $('.qv-quantity').val(currentQuantity - 1);
    }
  });
}

function updateVariantDetails(variant) {
  var price = parseFloat(variant.price / 100).toFixed(2);
  var original_price = parseFloat(variant.compare_at_price / 100).toFixed(2);

  $('.qv-product-price').text('£' + price);

  if (original_price > 0) {
    $('.qv-product-original-price').text('£' + original_price).show();
  } else {
    $('.qv-product-original-price').hide();
  }

  if (variant.inventory_quantity == 0 || variant.available == false) {
    $('.qv-add-button').prop('disabled', true).val('Sold Out');
  } else {
    $('.qv-add-button').prop('disabled', false).val('Add to bag');
    $('.qv-add-to-cart').show();
  }

  $('select.option-0').val(variant.option1);
  if (variant.option2) $('select.option-1').val(variant.option2);
  if (variant.option3) $('select.option-2').val(variant.option3);
}
